
(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-schema": { "availability": { "awayMessage": { "defaultMessageText": "We're away right now, but we'll get back to you as soon as we can." }, "outsideOfficeHoursMessage": { "defaultMessageText": "We're away right now, but we'll get back to you as soon as we can." } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-schema": {
    "cs": "static-2.4635",
    "da": "static-2.4635",
    "de": "static-2.4635",
    "el": "static-2.4635",
    "en": "static-2.4635",
    "es-mx": "static-2.4635",
    "es": "static-2.4635",
    "fi": "static-2.4635",
    "fr": "static-2.4635",
    "it": "static-2.4635",
    "ja": "static-2.4635",
    "ko": "static-2.4635",
    "nl": "static-2.4635",
    "no": "static-2.4635",
    "pl": "static-2.4635",
    "pt-br": "static-2.4635",
    "sv": "static-2.4635",
    "zh-cn": "static-2.4635",
    "zh-hk": "static-2.4635"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-schema": { "GDPR": { "header": "Data privacy & consent", "learnMore": "Learn more", "consentToProcess": { "label": "Consent to process data", "help": "Use the text field below to explain why you need to store and process your customer's personal information.", "processType": { "label": "Consent type", "options": { "consentButton": { "text": "Require explicit consent", "help": "Show \"consent to process\" button" }, "legitimateInterest": { "text": "Legitimate interest", "help": "Show \"consent to process\" text only" } } }, "processConsentText": { "label": "Process consent text" }, "validation": { "nonEmpty": "Process consent message is required", "tooLong": "This message is too long" } }, "consentToCommunicate": { "label": "Consent to communicate", "default": "I agree to receive other communications from {{ accountName }}", "checkboxLabel": "Checkbox label", "help": "Use the text field below to tell customers what type of communication they're consenting to.", "validation": { "nonEmpty": "Consent to communicate message is required", "tooLong": "This message is too long" } }, "preview": "Preview" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-schema": {
    "cs": "static-2.4635",
    "da": "static-2.4635",
    "de": "static-2.4635",
    "el": "static-2.4635",
    "en": "static-2.4635",
    "es-mx": "static-2.4635",
    "es": "static-2.4635",
    "fi": "static-2.4635",
    "fr": "static-2.4635",
    "it": "static-2.4635",
    "ja": "static-2.4635",
    "ko": "static-2.4635",
    "nl": "static-2.4635",
    "no": "static-2.4635",
    "pl": "static-2.4635",
    "pt-br": "static-2.4635",
    "sv": "static-2.4635",
    "zh-cn": "static-2.4635",
    "zh-hk": "static-2.4635"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-schema": { "default": { "repText": "Hi there! Let me know if you have any questions about the product or pricing.", "visitorText": "Can you go into a bit more detail about your pricing structure?", "name": "New chatflow ({{timeStamp}})", "qualifiedLead": { "initialMessage": "Hi there! I'm happy to help you today." }, "initialMessage": "Got any questions? I'm happy to help.", "askForEmailMessage": "Don’t have time to wait for a response? Leave your email and we’ll be in touch as soon as possible.", "awayMessage": "I'm away at the moment, but let me know if you have any questions and I'll reply to you soon." }, "typicalResponseTime": { "standardResponses": { "FEW_MINUTES": "We typically reply in a few minutes", "FEW_HOURS": "We typically reply in a few hours", "WITHIN_DAY": "We typically reply in a day" }, "customResponses": { "MINUTES": { "zero": "We typically reply in {{ count }} minutes", "one": "We typically reply in {{ count }} minute", "other": "We typically reply in {{ count }} minutes" }, "HOURS": { "zero": "We typically reply in {{ count }} hours", "one": "We typically reply in {{ count }} hour", "other": "We typically reply in {{ count }} hours" }, "DAYS": { "zero": "We typically reply in {{ count }} days", "one": "We typically reply in {{ count }} day", "other": "We typically reply in {{ count }} days" } } }, "validationError": { "availability": "You must choose a time.", "customAwayMessage": { "required": "Away message is required", "tooLong": "Away message is too long." }, "targetAudienceId": "Please choose a value.", "targetAudienceType": "Please choose a target audience.", "inclusionUrls": "Please enter at least one valid web page URL.", "exclusionUrls": "Please enter a valid web page URL.", "name": "Please enter a valid name for this message.", "emptyUrl": "Please enter a valid web page URL.", "meetingsLinkText": "Please enter display text for your meetings link.", "meetingsLinkId": "You must choose a meetings link to display.", "fallbackUser": "Please choose a team member.", "emptyName": "Please name your message.", "emptyNameTooltip": "Please name your message to continue.", "emptyMessage": "Please enter a message.", "accentColor": "Please enter a valid Hex color code.", "sendFromError": "Please choose at least one user or team." } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "conversations-schema": {
    "en": "static-2.4635"
  }
};
  result.translationsAvailable = {
  "conversations-schema": {
    "cs": "static-2.4635",
    "da": "static-2.4635",
    "de": "static-2.4635",
    "el": "static-2.4635",
    "en": "static-2.4635",
    "es-mx": "static-2.4635",
    "es": "static-2.4635",
    "fi": "static-2.4635",
    "fr": "static-2.4635",
    "it": "static-2.4635",
    "ja": "static-2.4635",
    "ko": "static-2.4635",
    "nl": "static-2.4635",
    "no": "static-2.4635",
    "pl": "static-2.4635",
    "pt-br": "static-2.4635",
    "sv": "static-2.4635",
    "zh-cn": "static-2.4635",
    "zh-hk": "static-2.4635"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-schema:en', {version: 'static-2.4635'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-internal-components": { "install-code-step": { "howToLink": "How do I add the code?", "copyButton": "Copy", "installCodeEmailForm": { "title": "Need someone else to install the code?", "description": "Email the code snippet to your web developer or admin.", "placeholder": "Enter email address", "error": "Please enter a valid email address.", "send": "Send" } }, "sendDisconnectedAccountEmailPrompt": { "title": "Ask an admin to reconnect email", "body": "Send an email to an account administrator asking them to reconnect <strong>{{ email }}</strong>", "confirm": "Send", "cancel": "Cancel", "placeholder": "Select administrator" }, "officeHours": { "willReturnAt": "We'll return {{ dayAndTime }}", "defaultMessageText": "We'll return tomorrow at 9:00 AM" }, "errorAlert": { "titleText": "Something went wrong.", "message_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Please try again. If it keeps happening, ",
createElement( options,
"Link",
{ onClick: props.onClick },
"let us know" ),
"." ); }, "eventId": "Event Id: {{ eventId }}" }, "notifications": { "unknownVisitor": "Unknown visitor", "title": { "withIdentity": "{{ identifier }} | HubSpot Messages" }, "newMessage": "New live chat from {{ identifier }}", "newEmail": "New email from {{ identifier }}", "assignment": "{{ identifier }} assigned a conversation to you.", "pushText": "A visitor has sent you a new message." }, "default": { "repText": "Hi there! Let me know if you have any questions about the product or pricing.", "initialMessage": "Got any questions? I'm happy to help.", "askForEmailMessage": "Don’t have time to wait for a response? Leave your email and we’ll be in touch as soon as possible.", "agent": "Agent" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "conversations-internal-components": {
    "en": "static-1.6126"
  }
};
  result.translationsAvailable = {
  "conversations-internal-components": {
    "cs": "static-1.6126",
    "da": "static-1.6126",
    "de": "static-1.6126",
    "el": "static-1.6126",
    "en": "static-1.6126",
    "es-mx": "static-1.6126",
    "es": "static-1.6126",
    "fi": "static-1.6126",
    "fr": "static-1.6126",
    "it": "static-1.6126",
    "ja": "static-1.6126",
    "ko": "static-1.6126",
    "nl": "static-1.6126",
    "no": "static-1.6126",
    "pl": "static-1.6126",
    "pt-br": "static-1.6126",
    "sv": "static-1.6126",
    "zh-cn": "static-1.6126",
    "zh-hk": "static-1.6126"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-internal-components:en', {version: 'static-1.6126'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-message-history": { "assignment": { "activeAgentSelfAssignment": "You reassigned this thread to yourself on {{ date }}", "activeAgentAssignor": { "default": "You reassigned this thread to {{ assigneeName }} on {{ date }}", "unknownAssignee": "You reassigned this thread on {{ date }}" }, "activeAgentAssignee": { "default": "{{ assignorName }} reassigned this thread to you on {{ date }}", "unknownAssignor": "This thread was reassigned to you on {{ date }}" }, "activeAgentUninvolved": { "default": "{{ assignorName }} reassigned this thread to {{ assigneeName }} on {{ date }}", "selfAssignment": "{{ assignorName }} self-assigned this thread on {{ date }}", "unknownAssignor": "This thread was reassigned to {{ assigneeName }} on {{ date }}", "unknownAssignee": "{{ assignorName }} reassigned this thread on {{ date }}", "unknownBoth": "This thread was reassigned on {{ date }}" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-message-history": {
    "cs": "static-1.1244",
    "da": "static-1.1244",
    "de": "static-1.1244",
    "el": "static-1.1244",
    "en": "static-1.1244",
    "es-mx": "static-1.1244",
    "es": "static-1.1244",
    "fi": "static-1.1244",
    "fr": "static-1.1244",
    "it": "static-1.1244",
    "ja": "static-1.1244",
    "ko": "static-1.1244",
    "nl": "static-1.1244",
    "no": "static-1.1244",
    "pl": "static-1.1244",
    "pt-br": "static-1.1244",
    "sv": "static-1.1244",
    "zh-cn": "static-1.1244",
    "zh-hk": "static-1.1244"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-message-history": { "crm-ticket-lifecycle-update": { "create": "{{ticketName}} ({{link}})", "createHeader": { "system": "New thread created a ticket", "currentAgent": "You created a ticket", "agent": "{{agent}} created a ticket", "formSubmission": "New submission from {{ formName }} automatically created ticket" }, "update": { "system": "The ticket status was changed to {{pipelineStage}} - {{dateString}}", "currentAgent": "You changed the ticket status to {{pipelineStage}} - {{dateString}}", "agent": "{{agent}} changed the ticket status to {{pipelineStage}} - {{dateString}}" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-message-history": {
    "cs": "static-1.1244",
    "da": "static-1.1244",
    "de": "static-1.1244",
    "el": "static-1.1244",
    "en": "static-1.1244",
    "es-mx": "static-1.1244",
    "es": "static-1.1244",
    "fi": "static-1.1244",
    "fr": "static-1.1244",
    "it": "static-1.1244",
    "ja": "static-1.1244",
    "ko": "static-1.1244",
    "nl": "static-1.1244",
    "no": "static-1.1244",
    "pl": "static-1.1244",
    "pt-br": "static-1.1244",
    "sv": "static-1.1244",
    "zh-cn": "static-1.1244",
    "zh-hk": "static-1.1244"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-message-history": { "crm-object-workflow-email-sent": { "default": "{{ visitorName }} was automatically sent the email notification {{ emailSubjectWithWorkflowLink }} on {{ date }}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-message-history": {
    "cs": "static-1.1244",
    "da": "static-1.1244",
    "de": "static-1.1244",
    "el": "static-1.1244",
    "en": "static-1.1244",
    "es-mx": "static-1.1244",
    "es": "static-1.1244",
    "fi": "static-1.1244",
    "fr": "static-1.1244",
    "it": "static-1.1244",
    "ja": "static-1.1244",
    "ko": "static-1.1244",
    "nl": "static-1.1244",
    "no": "static-1.1244",
    "pl": "static-1.1244",
    "pt-br": "static-1.1244",
    "sv": "static-1.1244",
    "zh-cn": "static-1.1244",
    "zh-hk": "static-1.1244"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-message-history": { "context-update-message": { "ENTRY_URL": "Chatting from: {{ value }}", "CUSTOM": "{{value}}", "CHATFLOW": "Chatting from chat flow: {{ value }}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-message-history": {
    "cs": "static-1.1244",
    "da": "static-1.1244",
    "de": "static-1.1244",
    "el": "static-1.1244",
    "en": "static-1.1244",
    "es-mx": "static-1.1244",
    "es": "static-1.1244",
    "fi": "static-1.1244",
    "fr": "static-1.1244",
    "it": "static-1.1244",
    "ja": "static-1.1244",
    "ko": "static-1.1244",
    "nl": "static-1.1244",
    "no": "static-1.1244",
    "pl": "static-1.1244",
    "pt-br": "static-1.1244",
    "sv": "static-1.1244",
    "zh-cn": "static-1.1244",
    "zh-hk": "static-1.1244"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-message-history": { "delivery-status": { "READ": "Read", "SENT": "Sent {{ source }}", "sources": { "FB_MESSENGER": "by messenger", "EMAIL": "by email", "LIVE_CHAT": "by chat", "UNKNOWN": "" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-message-history": {
    "cs": "static-1.1244",
    "da": "static-1.1244",
    "de": "static-1.1244",
    "el": "static-1.1244",
    "en": "static-1.1244",
    "es-mx": "static-1.1244",
    "es": "static-1.1244",
    "fi": "static-1.1244",
    "fr": "static-1.1244",
    "it": "static-1.1244",
    "ja": "static-1.1244",
    "ko": "static-1.1244",
    "nl": "static-1.1244",
    "no": "static-1.1244",
    "pl": "static-1.1244",
    "pt-br": "static-1.1244",
    "sv": "static-1.1244",
    "zh-cn": "static-1.1244",
    "zh-hk": "static-1.1244"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-message-history": { "email-capture": { "emailCaptureResponseText": "Visitor submitted their email: {{ email }}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-message-history": {
    "cs": "static-1.1244",
    "da": "static-1.1244",
    "de": "static-1.1244",
    "el": "static-1.1244",
    "en": "static-1.1244",
    "es-mx": "static-1.1244",
    "es": "static-1.1244",
    "fi": "static-1.1244",
    "fr": "static-1.1244",
    "it": "static-1.1244",
    "ja": "static-1.1244",
    "ko": "static-1.1244",
    "nl": "static-1.1244",
    "no": "static-1.1244",
    "pl": "static-1.1244",
    "pt-br": "static-1.1244",
    "sv": "static-1.1244",
    "zh-cn": "static-1.1244",
    "zh-hk": "static-1.1244"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-message-history": { "email-header": { "to": "to ", "popover": { "default": "Info", "to": "To:", "from": "From:", "date": "Date:", "subject": "Subject:", "bcc": "BCC:", "cc": "CC:" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-message-history": {
    "cs": "static-1.1244",
    "da": "static-1.1244",
    "de": "static-1.1244",
    "el": "static-1.1244",
    "en": "static-1.1244",
    "es-mx": "static-1.1244",
    "es": "static-1.1244",
    "fi": "static-1.1244",
    "fr": "static-1.1244",
    "it": "static-1.1244",
    "ja": "static-1.1244",
    "ko": "static-1.1244",
    "nl": "static-1.1244",
    "no": "static-1.1244",
    "pl": "static-1.1244",
    "pt-br": "static-1.1244",
    "sv": "static-1.1244",
    "zh-cn": "static-1.1244",
    "zh-hk": "static-1.1244"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-message-history": { "filtered-change": { "labels": { "you": { "default": "You modified this conversation on {{ dateString}}", "markedAsSpam": "You marked this conversation as spam on {{ dateString}}", "unmarkedAsSpam": "You unmarked this conversation as spam on {{ dateString}}", "blocked": "You blocked this email address on {{ dateString}}", "unblocked": "You unblocked this email address on {{ dateString}}" }, "agent": { "default": "{{ marker }} modified this conversation on {{ dateString}}", "markedAsSpam": "{{ marker }} marked this conversation as spam on {{ dateString}}", "unmarkedAsSpam": "{{ marker }} unmarked this conversation as spam on {{ dateString}}", "blocked": "{{ marker }} blocked this email address on {{ dateString}}", "unblocked": "{{ marker }} unblocked this email address on {{ dateString}}" } } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-message-history": {
    "cs": "static-1.1244",
    "da": "static-1.1244",
    "de": "static-1.1244",
    "el": "static-1.1244",
    "en": "static-1.1244",
    "es-mx": "static-1.1244",
    "es": "static-1.1244",
    "fi": "static-1.1244",
    "fr": "static-1.1244",
    "it": "static-1.1244",
    "ja": "static-1.1244",
    "ko": "static-1.1244",
    "nl": "static-1.1244",
    "no": "static-1.1244",
    "pl": "static-1.1244",
    "pt-br": "static-1.1244",
    "sv": "static-1.1244",
    "zh-cn": "static-1.1244",
    "zh-hk": "static-1.1244"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-message-history": { "initial-message": { "header": "Welcome message", "headerTooltip": "A welcome message is a prompt used to invite your website visitors to start a conversation." } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-message-history": {
    "cs": "static-1.1244",
    "da": "static-1.1244",
    "de": "static-1.1244",
    "el": "static-1.1244",
    "en": "static-1.1244",
    "es-mx": "static-1.1244",
    "es": "static-1.1244",
    "fi": "static-1.1244",
    "fr": "static-1.1244",
    "it": "static-1.1244",
    "ja": "static-1.1244",
    "ko": "static-1.1244",
    "nl": "static-1.1244",
    "no": "static-1.1244",
    "pl": "static-1.1244",
    "pt-br": "static-1.1244",
    "sv": "static-1.1244",
    "zh-cn": "static-1.1244",
    "zh-hk": "static-1.1244"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-message-history": { "responder": { "automatic": "Automated", "bot": "Bot", "unknownResponder": "Unknown user", "unknownSender": "Unknown sender", "unknownVisitor": "Unknown visitor" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-message-history": {
    "cs": "static-1.1244",
    "da": "static-1.1244",
    "de": "static-1.1244",
    "el": "static-1.1244",
    "en": "static-1.1244",
    "es-mx": "static-1.1244",
    "es": "static-1.1244",
    "fi": "static-1.1244",
    "fr": "static-1.1244",
    "it": "static-1.1244",
    "ja": "static-1.1244",
    "ko": "static-1.1244",
    "nl": "static-1.1244",
    "no": "static-1.1244",
    "pl": "static-1.1244",
    "pt-br": "static-1.1244",
    "sv": "static-1.1244",
    "zh-cn": "static-1.1244",
    "zh-hk": "static-1.1244"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-message-history": { "status": { "closed": "This thread was closed on {{ dateString }}", "restore": "Restore this message", "publishing": { "UNPUBLISHED": "Sending... ", "PUBLISH_FAILED": "Not delivered. Click to retry." } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-message-history": {
    "cs": "static-1.1244",
    "da": "static-1.1244",
    "de": "static-1.1244",
    "el": "static-1.1244",
    "en": "static-1.1244",
    "es-mx": "static-1.1244",
    "es": "static-1.1244",
    "fi": "static-1.1244",
    "fr": "static-1.1244",
    "it": "static-1.1244",
    "ja": "static-1.1244",
    "ko": "static-1.1244",
    "nl": "static-1.1244",
    "no": "static-1.1244",
    "pl": "static-1.1244",
    "pt-br": "static-1.1244",
    "sv": "static-1.1244",
    "zh-cn": "static-1.1244",
    "zh-hk": "static-1.1244"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-message-history": { "commentMessageSubject": "{{ name }} left a comment {{ timestamp }}", "commentMessageTooltip": "{{ icon }} Only visible to your team", "noContent": "This message has no content" } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "conversations-message-history": {
    "en": "static-1.1244"
  }
};
  result.translationsAvailable = {
  "conversations-message-history": {
    "cs": "static-1.1244",
    "da": "static-1.1244",
    "de": "static-1.1244",
    "el": "static-1.1244",
    "en": "static-1.1244",
    "es-mx": "static-1.1244",
    "es": "static-1.1244",
    "fi": "static-1.1244",
    "fr": "static-1.1244",
    "it": "static-1.1244",
    "ja": "static-1.1244",
    "ko": "static-1.1244",
    "nl": "static-1.1244",
    "no": "static-1.1244",
    "pl": "static-1.1244",
    "pt-br": "static-1.1244",
    "sv": "static-1.1244",
    "zh-cn": "static-1.1244",
    "zh-hk": "static-1.1244"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-message-history:en', {version: 'static-1.1244'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} of {{totalBytes}}" }, "fileSizeLimit": "{{size}} max upload" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-experience-components": {
    "cs": "static-1.595",
    "da": "static-1.595",
    "de": "static-1.595",
    "el": "static-1.595",
    "en": "static-1.595",
    "es-mx": "static-1.595",
    "es": "static-1.595",
    "fi": "static-1.595",
    "fr": "static-1.595",
    "it": "static-1.595",
    "ja": "static-1.595",
    "ko": "static-1.595",
    "nl": "static-1.595",
    "no": "static-1.595",
    "pl": "static-1.595",
    "pt-br": "static-1.595",
    "sv": "static-1.595",
    "zh-cn": "static-1.595",
    "zh-hk": "static-1.595"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "There was a network connection issue.", "message": "Please check your connection and try again.", "button": "Try again" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-experience-components": {
    "cs": "static-1.595",
    "da": "static-1.595",
    "de": "static-1.595",
    "el": "static-1.595",
    "en": "static-1.595",
    "es-mx": "static-1.595",
    "es": "static-1.595",
    "fi": "static-1.595",
    "fr": "static-1.595",
    "it": "static-1.595",
    "ja": "static-1.595",
    "ko": "static-1.595",
    "nl": "static-1.595",
    "no": "static-1.595",
    "pl": "static-1.595",
    "pt-br": "static-1.595",
    "sv": "static-1.595",
    "zh-cn": "static-1.595",
    "zh-hk": "static-1.595"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Sorry. We were unable to verify your email address." } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-experience-components": {
    "en": "static-1.595"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-visitor-experience-components": { "visitorWidget": { "header": { "threadListTitle": "Conversations" }, "threadList": { "header": "Welcome to {{ company }}!", "subHeader": "We're here to answer all your questions." } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-experience-components": {
    "cs": "static-1.595",
    "da": "static-1.595",
    "de": "static-1.595",
    "el": "static-1.595",
    "en": "static-1.595",
    "es-mx": "static-1.595",
    "es": "static-1.595",
    "fi": "static-1.595",
    "fr": "static-1.595",
    "it": "static-1.595",
    "ja": "static-1.595",
    "ko": "static-1.595",
    "nl": "static-1.595",
    "no": "static-1.595",
    "pl": "static-1.595",
    "pt-br": "static-1.595",
    "sv": "static-1.595",
    "zh-cn": "static-1.595",
    "zh-hk": "static-1.595"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-visitor-experience-components": { "install-code-step": { "description": "<p>Copy the code below and paste it into every page you’d like chat to appear on. When you’re adding the code, make sure it’s placed just before the end of the &lt;body&gt; tag. You can also add it to your site footer.</p><p>If you’re a Marketing customer using the HubSpot CMS, you don't need to do anything. Your tracking code is automatically installed on all HubSpot-hosted pages.</p>", "howToLink": "How do I add the code?", "copyButton": "Copy", "installCodeEmailForm": { "title": "Need someone else to install the code?", "description": "Email the code snippet to your web developer or admin.", "placeholder": "Enter email address", "error": "Please enter a valid email address.", "send": "Send" } }, "officeHours": { "willReturnAt": "We'll return {{ dayAndTime }}", "defaultMessageText": "We'll return tomorrow at 9:00 AM" }, "alerts": { "pubNubStatus": { "visiblyOffline": { "title": "Sorry. There was an issue connecting to the network. ", "description": "Please wait a few seconds and try again." }, "PNNetworkUpCategory": { "title": "The network connection issue is resolved.", "description": "Success! You're connected to messages again." }, "PNRsubscribeLimitReached": { "title": "Sorry. We can't connect you to messages right now.", "description": "Please refresh your page." } } }, "errorAlert": { "titleText": "Something went wrong.", "message_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Please try again. If it keeps happening, ",
createElement( options,
"Link",
{ onClick: props.onClick },
"let us know" ),
"." ); }, "eventId": "Event Id: {{ eventId }}" }, "unknownVisitor": "Unknown visitor", "notifications": { "unknownVisitor": "Unknown visitor", "title": { "withIdentity": "{{ identifier }} | HubSpot Messages" }, "newMessage": "New live chat from {{ identifier }}", "newEmail": "New email from {{ identifier }}", "assignment": "{{ identifier }} assigned a conversation to you.", "pushText": "A visitor has sent you a new message." }, "buttons": { "agree": "I agree" }, "visitorExperienceAriaLabels": { "dismiss": "Dismiss", "open": "Open live chat", "close": "Close live chat", "attachment": "attach a file", "send": "send message", "showThreadList": "View thread list, {{ unreadThreadCount }} unread threads", "createNewThread": "Create new thread" }, "chatArea": { "branding_jsx": function (createElement, options, props) { return createElement( options,
"wrapper",
null,
"Add free ",
createElement( options,
"Link",
props,
"live chat" ),
" to your site" ); }, "brandingAriaLabel": "Add free live chat to your site" }, "chatTextArea": { "validationMessage": "Message is too long.", "placeholder": "Write a message" }, "newThreadPrompt": { "heading": "Your chat has ended.", "paragraph": "Ask more questions by starting a new chat.", "button": "Start new chat" }, "botAwayMessage": { "heading": "Our team isn't online at the moment.", "paragraph": "We'll be back during our business hours and look forward to chatting with you then." }, "default": { "repText": "Hi there! Let me know if you have any questions about the product or pricing.", "initialMessage": "Got any questions? I'm happy to help.", "askForEmailMessage": "Don’t have time to wait for a response? Leave your email and we’ll be in touch as soon as possible.", "agent": "Agent" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "conversations-visitor-experience-components": {
    "en": "static-1.595"
  }
};
  result.translationsAvailable = {
  "conversations-visitor-experience-components": {
    "cs": "static-1.595",
    "da": "static-1.595",
    "de": "static-1.595",
    "el": "static-1.595",
    "en": "static-1.595",
    "es-mx": "static-1.595",
    "es": "static-1.595",
    "fi": "static-1.595",
    "fr": "static-1.595",
    "it": "static-1.595",
    "ja": "static-1.595",
    "ko": "static-1.595",
    "nl": "static-1.595",
    "no": "static-1.595",
    "pl": "static-1.595",
    "pt-br": "static-1.595",
    "sv": "static-1.595",
    "zh-cn": "static-1.595",
    "zh-hk": "static-1.595"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-visitor-experience-components:en', {version: 'static-1.595'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "ui-addon-conversations": { "email": { "header": { "emailToHeader": "{{ from }} to {{ to }}" }, "replies": { "hide": "Collapse", "show": "View Trimmed Content" }, "infoTable": { "to": "To", "from": "From", "cc": "cc", "bccKey": "bcc", "date": "Date", "subject": "Subject" }, "statusFooter": { "initializing": { "label": "Initializing" }, "sending": { "label": "Sending" }, "sent": { "label": "Sent" }, "bounced": { "label": "We couldn't deliver this message.", "description": "The message was sent but not delivered. Please check the recipient's email address and try again." }, "error": { "label": "Unable to send message.", "description": "Something went wrong. Please try again." }, "failed": { "label": "Unable to send message.", "description": "Something went wrong. Please try again." } } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "ui-addon-conversations": {
    "cs": "static-1.7045",
    "da": "static-1.7045",
    "de": "static-1.7045",
    "el": "static-1.7045",
    "en": "static-1.7045",
    "es-mx": "static-1.7045",
    "es": "static-1.7045",
    "fi": "static-1.7045",
    "fr": "static-1.7045",
    "it": "static-1.7045",
    "ja": "static-1.7045",
    "ko": "static-1.7045",
    "nl": "static-1.7045",
    "no": "static-1.7045",
    "pl": "static-1.7045",
    "pt-br": "static-1.7045",
    "sv": "static-1.7045",
    "zh-cn": "static-1.7045",
    "zh-hk": "static-1.7045"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "CrmTicketLifecycleUpdates": { "default": { "agent": "Agent" }, "createdBy": { "system": "<b>New {{threadType}} automatically</b> created ticket <b>{{ticketName}}</b>", "currentAgent": "<b>You</b> created ticket <b>{{ticketName}}</b>", "agent": "<b>{{agent}}</b> created ticket <b>{{ticketName}}</b>" }, "updatedBy": { "system": "Ticket status changed to {{pipelineStage}} {{dateString}}", "currentAgent": "Ticket status changed to {{pipelineStage}} by you {{dateString}}", "agent": "Ticket status changed to {{pipelineStage}} by {{agent}} {{dateString}}" }, "threadTypes": { "EMAIL": "email", "LIVE_CHAT": "chat", "FB_MESSENGER": "message" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "ui-addon-conversations": {
    "cs": "static-1.7045",
    "da": "static-1.7045",
    "de": "static-1.7045",
    "el": "static-1.7045",
    "en": "static-1.7045",
    "es-mx": "static-1.7045",
    "es": "static-1.7045",
    "fi": "static-1.7045",
    "fr": "static-1.7045",
    "it": "static-1.7045",
    "ja": "static-1.7045",
    "ko": "static-1.7045",
    "nl": "static-1.7045",
    "no": "static-1.7045",
    "pl": "static-1.7045",
    "pt-br": "static-1.7045",
    "sv": "static-1.7045",
    "zh-cn": "static-1.7045",
    "zh-hk": "static-1.7045"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "ui-addon-conversations": { "status-change-labels": { "closed": "This thread was closed {{ dateString }}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "ui-addon-conversations": {
    "cs": "static-1.7045",
    "da": "static-1.7045",
    "de": "static-1.7045",
    "el": "static-1.7045",
    "en": "static-1.7045",
    "es-mx": "static-1.7045",
    "es": "static-1.7045",
    "fi": "static-1.7045",
    "fr": "static-1.7045",
    "it": "static-1.7045",
    "ja": "static-1.7045",
    "ko": "static-1.7045",
    "nl": "static-1.7045",
    "no": "static-1.7045",
    "pl": "static-1.7045",
    "pt-br": "static-1.7045",
    "sv": "static-1.7045",
    "zh-cn": "static-1.7045",
    "zh-hk": "static-1.7045"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "ui-addon-conversations": { "GDPR": { "consentToCommunicate": { "default": "I agree to receive other communications from {{ accountName }}" } }, "agent": "Agent", "spam-filtering-and-blocking": { "filterChangeLabels": { "markedAsSpam": "{{ marker }} marked this conversation as spam {{ dateString }}", "blocked": "{{ marker }} blocked this email address {{ dateString }}", "unmarkedAsSpam": "{{ marker }} unmarked this conversation as spam {{ dateString }}", "unblocked": "{{ marker }} unblocked this email address {{ dateString }}", "you": "You", "unknownResponder": "Unknown user" } }, "thread-deletion": { "restoreMessageLink": "Restore message", "messageDeleted": "This message has been deleted. {{ restoreMessageLink }}", "threadContainsDeletedMessages": { "title": { "one": "{{ count }} deleted message in this conversation. {{ viewLink }} or {{ deleteForeverLink }}", "other": "{{ count }} deleted messages in this conversation. {{ viewLink }} or {{ deleteForeverLink }}" }, "viewMessagesLink": "View messages", "deleteForeverLink": "delete forever" } }, "emailCapture": { "placeholderText": "Enter email address", "errorMessage": "You entered an invalid email.", "successMessage": "Thanks. We'll be in touch as soon as possible.", "maintenanceModeMessage": "You'll be notified of our response by email." }, "adminAccessRequired": "Please contact your administrator for edit access.", "chat": { "emailCapture": { "responseText": "Visitor submitted their email: {{ email }}" }, "responders": { "bot": "Bot", "unknown": "Unknown visitor" }, "urlMarker": "<b>Chatting from:</b> <a href={{url}} target='_blank'>{{url}}</a>", "visitorAway": "{{ visitorName }} left the page and may not see new messages right away.", "closedConversation": "Conversation closed {{ dateString }}", "dateStringWithAgo": "{{ dateString }} ago", "dateStringWithOn": "on {{ dateString }}", "assignmentLabels": { "roundRobin": "{{ assignee }} was automatically assigned to this conversation {{ dateString }}", "roundRobinYou": "You were automatically assigned to this conversation {{ dateString }}", "manualAssignment": "{{ assignor }} assigned this conversation to {{ assignee }} {{ dateString }}", "manualAssignmentAssigneeThemselves": "{{ assignor }} assigned this conversation to themselves {{ dateString }}", "manualAssignmentAssignorYou": "You assigned this conversation to {{ assignee }} {{ dateString }}", "manualAssignmentAssigneeYou": "{{ assignor }} assigned this conversation to you {{ dateString }}", "manualAssignmentYourself": "You assigned this conversation to yourself {{ dateString }}", "leadQualifierBot": "{{ assignee }} was assigned to this conversation by a lead qualifier bot {{ dateString }}", "leadQualifierBotYou": "You were assigned to this conversation by a lead qualifier bot {{ dateString }}", "unassignment": "This conversation has been unassigned", "unknownResponder": "Unknown user" }, "status": { "PUBLISHED": "Sent ", "UNPUBLISHED": "Sending... ", "PUBLISH_FAILED": "Not delivered. Click to retry." }, "inboxMessageStatus": { "SENT": "Sent", "UNPUBLISHED": "Sending... ", "PUBLISHED": "<b>Sent</b><span class=\"m-x-1\">•</span>{{timestamp}}", "READ": "<b>Read</b><span class=\"m-x-1\">•</span>{{timestamp}}", "PUBLISH_FAILED": "Not delivered. Click to retry.", "FAILED": "Not delivered. Click to retry." }, "messageSentTimestampTooltip": "Sent at {{timestamp}}", "welcomeMessage": "Welcome message", "welcomeMessageTooltip": "A welcome message is a prompt used to invite your website visitors to start a conversation.", "commentMessageSubject": "{{ name }} left a comment {{ timestamp }}", "context-update-message": { "ENTRY_URL": "Chatting from: {{ value }}" } } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "ui-addon-conversations": {
    "en": "static-1.7045"
  }
};
  result.translationsAvailable = {
  "ui-addon-conversations": {
    "cs": "static-1.7045",
    "da": "static-1.7045",
    "de": "static-1.7045",
    "el": "static-1.7045",
    "en": "static-1.7045",
    "es-mx": "static-1.7045",
    "es": "static-1.7045",
    "fi": "static-1.7045",
    "fr": "static-1.7045",
    "it": "static-1.7045",
    "ja": "static-1.7045",
    "ko": "static-1.7045",
    "nl": "static-1.7045",
    "no": "static-1.7045",
    "pl": "static-1.7045",
    "pt-br": "static-1.7045",
    "sv": "static-1.7045",
    "zh-cn": "static-1.7045",
    "zh-hk": "static-1.7045"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:ui-addon-conversations:en', {version: 'static-1.7045'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "ui": { "UICarousel": { "current": "Showing item {{currentStepDisplayNumber}} out of {{totalSteps}}", "prev": "Previous", "next": "Next", "tip": "Use arrow keys to see other items" }, "UIErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." } }, "UIPanelNavigator": { "backButton": "Go to previous screen" }, "UILoadingSpinner": { "busyText": "Loading", "completedText": "Loaded" }, "time": { "today": "Today at {{time}}", "yesterday": "Yesterday at {{time}}", "datetime": "{{date}} at {{time}}" }, "progress": { "percentComplete": "{{percent}} complete" }, "datePicker": { "type": "date picker", "dateSelected": "{{date}} is selected. Press 'Escape' to clear.", "noDateSelected": "No date selected. Use the arrow keys to navigate.", "dateFocused": "{{date}}. Press 'Enter' to select.", "placeholder": { "month": "MM", "day": "DD", "year": "YYYY" } } }, "salesUI": { "UIAbstractDateInput": { "invalidDate": "Invalid date", "dateBelowMin": "You must choose a newer date", "dateAboveMax": "You must choose an older date" }, "UIAvatarHoverlay": { "text": "Change photo" }, "UIChangeArrow": { "decrease": "Decrease of ", "increase": "Increase of " }, "UICopyInput": { "label": "Copy", "title": "Copy to clipboard", "tooltipCopied": "Copied" }, "UIConfirm": { "defaultConfirm": "Yes", "defaultReject": "No" }, "UICloseButton": { "label": "Close" }, "UIDateRangePicker": { "placeholder": "Select a range", "rangeType": { "ALL": "All time", "THIS_DAY": "Today", "LAST_DAY": "Yesterday", "THIS_WEEK": "This week", "LAST_WEEK": "Last week", "THIS_MONTH": "This month", "LAST_MONTH": "Last month", "LAST_THIRTY_DAYS": "Last 30 days", "LAST_THREE_MONTHS": "Last 3 months", "THIS_QUARTER": "This quarter", "LAST_QUARTER": "Last quarter", "THIS_YEAR": "This year", "LAST_YEAR": "Last year", "CUSTOM": "Custom time period" } }, "UIDateRangeInputs": { "invalidDateRange": "Please select an end date that isn't before the given start date" }, "UIDropdownSelect": { "placeholder": "No value selected" }, "UIEditableControls": { "cancel": "Cancel", "save": "Save" }, "UIExpandableText": { "collapseButtonText": "See less", "expandButtonText": "See more" }, "UIFileInput": { "defaultChangeLabel": "Change file", "defaultSelectLabel": "Choose file" }, "UIHelpButton": { "clickForHelp": "Click for help" }, "UIIconRating": { "ariaValueText": "{{value}} of {{maxValue}}" }, "UILink": { "externalTitle": "Link opens in a new window" }, "UILoading": { "title": "Loading…" }, "UILockBadge": { "title": "This feature is locked" }, "UIPaginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "UIPreviousButton": { "label": "Previous" }, "UINextButton": { "label": "Next" }, "UINumberRating": { "lowRangeLabel": "Strongly disagree", "highRangeLabel": "Strongly agree" }, "UISearchableSelectInput": { "placeholder": "Search" }, "UISearchInput": { "placeholder": "Search", "minimumSearchMessage": { "one": "Type 1 more character", "other": "Type {{count}} more characters" } }, "UISelect": { "allOptionsSelected": "All options are selected", "createOption": "Create option “{{label}}”", "plusMore": "+ {{count}} more", "andMore": "…and {{count}} more.", "loadMore": "Load more", "noResults": "No results found", "placeholder": "Search", "typeToSearch": "Type to search" }, "UITableSortToggle": { "ascendingSort": "Ascending sort", "descendingSort": "Descending sort", "noSort": "No sort" }, "UITabs": { "moreDropdownLabel": "More" }, "UITeaseNotification": { "optionsButtonTooltipText": "Show options" }, "UITextArea": { "characterCounter": { "one": "{{count}} character", "other": "{{count}} characters" } }, "UITextToolbarButton": { "remove": "Remove {{name}}", "noop": "You can't {{name}} the current selection" }, "UITimePicker": { "placeholder": "Select a time" }, "UIToggle": { "checkedLabel": "ON", "uncheckedLabel": "OFF" }, "UITypeahead": { "noMatchesFound": "No matches found", "noOptions": "None" }, "UIWizard": { "back": "Back", "cancel": "Cancel", "done": "Done", "next": "Next", "stepCount": "Step {{stepNumber}} of {{stepCount}}" }, "XSSTooltip": { "explanation": "This link has been disabled for your security." } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "UIComponents": {
    "en": "static-2.2495"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "cs": "static-2.2495",
    "da": "static-2.2495",
    "de": "static-2.2495",
    "el": "static-2.2495",
    "en": "static-2.2495",
    "es-mx": "static-2.2495",
    "es": "static-2.2495",
    "fi": "static-2.2495",
    "fr": "static-2.2495",
    "it": "static-2.2495",
    "ja": "static-2.2495",
    "ko": "static-2.2495",
    "nl": "static-2.2495",
    "no": "static-2.2495",
    "pl": "static-2.2495",
    "pt-br": "static-2.2495",
    "sv": "static-2.2495",
    "zh-cn": "static-2.2495",
    "zh-hk": "static-2.2495"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-2.2495'}); }
})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "cvVisitorUIAttachments": { "errors": { "fileSizeExceeded": "File exceeds the {{maxSize}} max upload.", "blacklistedExtension": "That file type is not allowed.", "uploadError": "Unable to upload attachment." }, "tryAgain": "Try again", "threadPreview": "An attachment has been sent" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-ui": {
    "cs": "static-1.6418",
    "da": "static-1.6418",
    "de": "static-1.6418",
    "el": "static-1.6418",
    "en": "static-1.6418",
    "es-mx": "static-1.6418",
    "es": "static-1.6418",
    "fi": "static-1.6418",
    "fr": "static-1.6418",
    "it": "static-1.6418",
    "ja": "static-1.6418",
    "ko": "static-1.6418",
    "nl": "static-1.6418",
    "no": "static-1.6418",
    "pl": "static-1.6418",
    "pt-br": "static-1.6418",
    "sv": "static-1.6418",
    "zh-cn": "static-1.6418",
    "zh-hk": "static-1.6418"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversationsVisitorUIAvailability": { "sameDay": "We'll return today at {{time}}", "nextDay": "We'll return tomorrow at {{time}}", "nextWeek": "We'll return {{dayOfWeek}} at {{time}}" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-ui": {
    "cs": "static-1.6418",
    "da": "static-1.6418",
    "de": "static-1.6418",
    "el": "static-1.6418",
    "en": "static-1.6418",
    "es-mx": "static-1.6418",
    "es": "static-1.6418",
    "fi": "static-1.6418",
    "fr": "static-1.6418",
    "it": "static-1.6418",
    "ja": "static-1.6418",
    "ko": "static-1.6418",
    "nl": "static-1.6418",
    "no": "static-1.6418",
    "pl": "static-1.6418",
    "pt-br": "static-1.6418",
    "sv": "static-1.6418",
    "zh-cn": "static-1.6418",
    "zh-hk": "static-1.6418"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "New Message" } } };
  result.translations = module.exports;
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-ui": {
    "cs": "static-1.6418",
    "da": "static-1.6418",
    "de": "static-1.6418",
    "el": "static-1.6418",
    "en": "static-1.6418",
    "es-mx": "static-1.6418",
    "es": "static-1.6418",
    "fi": "static-1.6418",
    "fr": "static-1.6418",
    "it": "static-1.6418",
    "ja": "static-1.6418",
    "ko": "static-1.6418",
    "nl": "static-1.6418",
    "no": "static-1.6418",
    "pl": "static-1.6418",
    "pt-br": "static-1.6418",
    "sv": "static-1.6418",
    "zh-cn": "static-1.6418",
    "zh-hk": "static-1.6418"
  }
};
  hns('I18n', result);

})();



(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "conversations-visitor-ui": { "default": { "agent": "Agent", "meetingsLinkText": "Schedule some time with me" }, "emailCapture": { "outsideOfficeHoursMessage": "Leave your email and we’ll be in touch as soon as possible.", "defaultAwayEmailCaptureMessage": "What email address should we use to follow up?" }, "messagePreview": { "error": { "title": "Something went wrong while trying to preview this message.", "description": "Please try again later." } }, "threadList": { "header": "Your chats", "seeAllButton": "See all", "seeLessButton": "See less" }, "network": { "offline": { "title": "Sorry. It looks like there was an issue with your internet connection. Please check your connection and try again." }, "pubSubFailure": { "title": "Sorry. There seems to be a connection issue. Please try again later.", "retry": "Try again" }, "newThreadFailure": { "title": "Sorry. There was a problem loading this message. Please check your connection and try again." } }, "asyncError": { "body": "We're having technical difficulties", "retry": "Retry" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "conversations-visitor-ui": {
    "en": "static-1.6418"
  }
};
  result.translationsAvailable = {
  "conversations-visitor-ui": {
    "cs": "static-1.6418",
    "da": "static-1.6418",
    "de": "static-1.6418",
    "el": "static-1.6418",
    "en": "static-1.6418",
    "es-mx": "static-1.6418",
    "es": "static-1.6418",
    "fi": "static-1.6418",
    "fr": "static-1.6418",
    "it": "static-1.6418",
    "ja": "static-1.6418",
    "ko": "static-1.6418",
    "nl": "static-1.6418",
    "no": "static-1.6418",
    "pl": "static-1.6418",
    "pt-br": "static-1.6418",
    "sv": "static-1.6418",
    "zh-cn": "static-1.6418",
    "zh-hk": "static-1.6418"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-visitor-ui:en', {version: 'static-1.6418'}); }
})();


